module.exports = __webpack_public_path__ + "img/deV.f63b7ecc.png";